import { render, staticRenderFns } from "./relicFiles.vue?vue&type=template&id=6e04ae2a&scoped=true&"
import script from "./relicFiles.vue?vue&type=script&lang=js&"
export * from "./relicFiles.vue?vue&type=script&lang=js&"
import style0 from "./relicFiles.vue?vue&type=style&index=0&id=6e04ae2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e04ae2a",
  null
  
)

export default component.exports